import { Button, HStack, SubmitButton } from '@medely/ui-kit';
import React from 'react';

type ApplicationButtonsProps = {
  disabled: boolean;
  backClick: () => void;
  loading?: boolean;
  onContinueClick?: () => void;
};

export const ApplicationButtons = ({
  disabled,
  backClick,
  onContinueClick,
  loading,
}: ApplicationButtonsProps) => {
  return (
    <HStack gap={2}>
      <Button
        disabled={disabled}
        onClick={backClick}
        loading={loading}
        testId="application-back-button"
        variant="outlined"
        fullWidth
      >
        Back
      </Button>

      <SubmitButton
        disabled={disabled}
        loading={loading}
        testId="application-continue-button"
        onClick={() => onContinueClick?.()}
        fullWidth
      >
        Continue
      </SubmitButton>
    </HStack>
  );
};
